import {
  EulerEvent,
  HorseRacingChoice,
  HorseRacingMarket,
} from "@virtuallysports/vs-utils";

type Choices = HorseRacingChoice[];

export class Market {
  id: string;
  betcode: string;
  choices: Choices;
  choicesNum: string;
  description: string;
  isMainMarket: boolean;
  type: string;
  status: string;
  shortDescr: string;

  constructor(market: HorseRacingMarket) {
    this.id = market.id;
    this.betcode = market.betcode;
    this.choices = market.choices;
    this.choicesNum = market.choicesNum;
    this.description = market.description;
    this.isMainMarket = market.isMainMarket;
    this.type = market.type;
    this.status = market.status;
    this.shortDescr = market.shortDescr;
  }

  public static createMarket(market: HorseRacingMarket) {
    return new Market(market);
  }

  public getMarket() {
    return {
      id: this.id,
      name: this.betcode,
      status: this.status,
    };
  }

  public getId() {
    return this.id;
  }

  public getBetcode() {
    return this.betcode;
  }

  public getStatus() {
    return this.status;
  }

  public getChoices() {
    return this.choices;
  }

  public getChoicesNum() {
    return this.choicesNum;
  }

  public getDescription() {
    return this.description;
  }

  public getIsMainMarket() {
    return this.isMainMarket;
  }

  public getType() {
    return this.type;
  }

  public getShortDescr() {
    return this.shortDescr;
  }
}
